import styled, { css } from 'styled-components';
import { media, layout } from '@prisjakt/ui-base';
import { LIST_DELETE_TRANSITION_TIME } from '../../constants';

type DragItemProps = {
  highlighted: boolean;
  deleted: boolean;
  deleting: boolean;
  hovered: boolean;
};

export const DragItem = styled.div<DragItemProps>`
  width: 100%;
  display: flex;
  background-color: ${p => p.theme.bg.primary};
  opacity: 1;
  border-radius: 5px;
  margin-bottom: ${layout.spacing.xSmall};

  ${media.mediumDown<DragItemProps>`
    ${props =>
      props.highlighted &&
      !props.deleted &&
      css`
        opacity: 0.4;
      `}

    ${props =>
      props.hovered &&
      !props.deleted &&
      css`
        opacity: 1;
      `}
    `};

  ${props =>
    props.deleting &&
    css`
      transition: max-height ${LIST_DELETE_TRANSITION_TIME}ms ease,
        opacity ${LIST_DELETE_TRANSITION_TIME}ms ease;
      opacity: 0;
      max-height: 0;
      overflow: hidden;
    `}
`;

export const DragHandle = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: grab;

  svg path {
    fill: ${p => p.theme.icons.primary};
  }
`;
